import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {AuthenticationService} from "./authentication.service";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";

@Injectable()
export class CanDo implements CanActivate {
    constructor(private auth: AuthenticationService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return Observable.create((observer: Observer<any>) => {
            this.auth.isAuthenticated().subscribe(
                (isAuthenticated: boolean) => {
                    if (isAuthenticated === false) {
                        return;
                    }

                    let canDo  = route.data['canDo'] as Array<string>;
                    if (!canDo) {
                        return;
                    }
                    
                    let result = this.auth.canDoAny(canDo);

                    if (result === false) {
                        this.router.navigate(['/home']);
                    }

                    observer.next(result);

                    return;
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/CanDo.ts